import axios from 'axios';
import qs from 'qs';

import { getTodaysDate } from './getters';

const PARDOT_BASEURL = 'https://go.pardot.com';
const PARDOT_ENDPOINTS = {
  newsletter: `${PARDOT_BASEURL}/l/552772/2019-07-11/5s4kd`,
  unsubscribe: `${PARDOT_BASEURL}/l/552772/2021-04-12/tff3v`
};

const postPardotData = (url, data) =>
  axios
    .request({
      url,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data: qs.stringify(data),
      method: 'POST'
    })
    .catch((err) => {
      console.log(err);
    });

export const PardotApi = {
  newsletter(userData, language) {
    const { email } = userData;
    if (!email) return;
    const data = {
      email,
      language
    };
    return postPardotData(PARDOT_ENDPOINTS.newsletter, data);
  },
  unsubscribe(userData) {
    const {
      email,
      reasonForUnsubscribe,
      tellUsMore,
      marketInsights,
      productReleases,
      smarterShipping,
      convelioInsider,
      directContacts,
      optIn,
      optOut
    } = userData;

    const data = {
      email,
      date: getTodaysDate(),
      reasonforunsubscribe: reasonForUnsubscribe,
      tellusmore: tellUsMore,
      marketinsights: marketInsights,
      productreleases: productReleases,
      smartershipping: smarterShipping,
      convelioinsider: convelioInsider,
      directcontacts: directContacts,
      optin: optIn,
      optout: optOut
    };
    return postPardotData(PARDOT_ENDPOINTS.unsubscribe, data);
  }
};
